export default {
  general: {
    Start: "Start",
    Back: "Back",
    Next: "Next",
    Cancel: "Cancel",
    Skip: "Skip",
    Preview: "Preview",
    Email: "Enter your email",
    EmailHint: "Email",
    Phone: "Enter phone number",
    PhoneHint: "Phone number",
    Password: "Enter your password",
    PasswordHint: "Password",
    PasswordReenter: "Reenter your password",
    CreatePasswordTitle: "Create a password to secure your account and ensure safe access.",
    CreatePasswordCheck: "Should be at least {1}8 characters long{2}, include {3}small{4} and {5}big{6} letters, {7}digit{8}  and {9}special character{10}.",
    CreatePasswordMustMatch: "Password must match.",
    CreateNewPassword: "Create a new password ",
    Setup: "Setup",
    Create: "Create",
    RememberMe: "Remember me",
    ForgotPassword: "Forgot password?",
    Login: "Login",
    Logout: "Logout",
    CloseAccount: "Close account",    
    CloseAccountAsk: "Do you really want to close account?",
    Yes: "Yes",
    No: "No",
    or: "or",
    Add: "Add",
    DontHaveAccount: "Don't have an account?",
    Register: "Register",
    Verify: "Verify",
    Send: "Send",
    TryAgain: "Try again",
    EnterName: "Enter your surname",
    EnterNameHint: "Name",
    EnterSurname: "Enter your surname",
    EnterSurnameHint: "Surname",
    Connecting: "Connecting...",
    Search: "Search",
    Generate: "Generate",
    Finish: "Finish",
    Save: "Save",
    SaveInProgres: "Saving in progress..."
  },

  bottomPanel: {
    Profile: "Profile",
    Tasks: "Tasks",
    Host: "Host",
    Messages: "Messages",
    Alerts: "Alerts"
  },

  login: {
    VerificationTitleEmail: "Enter the verification code sent to your email.",
    VerificationTitlePhone: "Enter the verification code sent to your phone.",
    HaventReceivedCode: "Haven’t received email?",
    CodeSendPhone: "The verification code has been send to your phone.",
    CodeSendEmail: "The verification code has been send to your email.",
    CodeSendFailed: "Can't send verification code.",
    CodeSendDisabled: "Please wait {1} sec. before you can request the verification code again.",
    CodeWrong: "Wrong code, try again.",
    EnterFullName: "Please enter your full name to complete your profile.",
    AgreeTo: "I agree to",
    TermsConditions: "Terms & Conditions",
    PasswordResetTitle: "Please provide the email address where the password reset link will be sent.",
    PasswordResetSend: "An instruction to reset your password has been sent to the provided email address.",
    PasswordResetNew: "The new password has been set.",
    CantCreateAccount: "Unable to create account. Please try again later.",
    CantLogin: "Can't log in, invalid login details.",
    LoginDeactivated: "Can't log in, your account is closed. Please contact support to reopen your account.",
    PropertiesTitle: "Properties",
    PropertiesDescription: "A fast, convenient, and transparent way to showcase your property and attract the right clients.",
    GuestsTitle: "Guests",
    GuestsDescription: "Your complete guest database, giving you quick access to previous contacts. Easily get in touch and invite them again, with all communication and activity history in one place.",
    OffersTitle: "Offers",
    OffersDesctiption: "Stay up to date with all sent rental offers, receive automatic reminders to ensure nothing is missed, and guide your offer towards a successful booking.",
    ReservationsTitle: "Reservations",
    ReservationsDescription: "A clear and intuitive way to manage reservations. Know exactly when your guests are visiting, with task reminders to provide top-notch service.",
    MarketingTitle: "Marketing",
    MarketingDescription: "An efficient tool for creating engaging marketing content on Facebook and Instagram, powered by artificial intelligence.",
    FinanceTitle: "Finance",
    FinanceDescription: "A simple, user-friendly overview of your property's finances, including return on investment and customer payments - all in one place.",
    StatisticsTitle: "Statistics",
    StatisticsDescription: "A quick overview of the key metrics regarding your property to help track performance, and with the help of AI, receive suggestions on what to focus on next."
  },

  termsConditions: {
    title: "Terms and Conditions",
    introduction: "Welcome to our website! By accessing or using our services, you agree to comply with and be bound by the following Terms and Conditions.",
    useOfWebsite: "You agree to use this website for lawful purposes only. You must not use this website in any way that could damage, disable, or impair the website's functionality.",
    accountRegistration: "If you create an account on our website, you are responsible for maintaining the confidentiality of your login details and for all activities that occur under your account.",
    intellectualProperty: "All content on this website, including text, graphics, and logos, is the property of the website owner and is protected by copyright laws.",
    privacyPolicy: "Your privacy is important to us. Please refer to our Privacy Policy for details on how we handle your personal information.",
    limitationOfLiability: "We are not liable for any damages or losses arising from your use of the website. You agree to use the website at your own risk.",
    modifications: "We reserve the right to modify these Terms and Conditions at any time. Changes will be posted on this page, and it is your responsibility to review them periodically.",
    governingLaw: "These Terms and Conditions are governed by the laws of the jurisdiction where the website owner is located. Any disputes will be resolved in the appropriate courts of that jurisdiction.",
    contactUs: "If you have any questions or concerns about these Terms and Conditions, please contact us."
  },

  host: {
    Properties: "Properties",
    PropertyDescribe: "Describe the property",
    Guests: "Guests",
    GuestAdd: "Add guest",
    Places: "Places",
    PlaceDescribe: "Describle the place",
    PlaceAI: "Enter some details about place you want to add to generate it automatically.",
    Attractions: "Attractions",
    AttractionDescribe: "Describe the attraction",
    AttractionAI: "Enter some details about attraction you want to add to generate it automatically.",
    Dishes: "Dishes",
    DisheDescribe: "Describe the dish",
    Restaurants: "Restaurants",
    RestaurantDescribe: "Describe the restaurant",
    Offers: "Offers",
    OfferAdd: "Add offer",
    Reservations: "Reservations",
    ReservationAdd: "Add reservation",
    Marketing: "Marketing",
    Statistics: "Statistics",
    Finance: "Finance",
    Calendar: "Calendar",
    Overview: "Overview",
    Gallery: "Gallery",    
    AttractionOverview: "Attraction overview",
    PlaceOverview: "Place overview",
    DishOverview: "Dish overview",
    RestaurantOverview: "Restaurant overview",
    AddFailed: "An error occurred while adding.",
    UpdateFailed: "An error occurred while saving.",
    AddOk: "Added successfully.",
    UpdateOk: "Saved successfully.",
    UniqueIdExists: "Unique ID has already been used, please select another one.",
    ListEmpty: "The list is empty, add the first item.",
    ListCantLoadItem: "Can't load item!",
    ListCancelAsk: "Are you sure you want to lose the changes made?",
    DeleteItemAsk: "Do you really want to delete this item?",
    DeleteItemOk: "Item deleted.",
    DeleteItemFailed: "Can’t delete item!"
  },

  edit: {
    Name: "Name",
    NameHint: "Enter name",
    Slogan: "Slogan",
    SloganHint: "Enter slogan",
    PhotoAdd: "Add photos",
    PhotoSelect: "Gallery is empty",
    PhotoChangeOrder: "Hold and move the photos to arrange the order. First photo will be the thumbnail.",
    Description: "Description",
    DescriptionAdd: "Add description",
    AttractionsAdd: "Add attractions",
    RestaurantsAdd: "Add restaurants",
    FactsAdd: "Add interesting facts",
    DetailsAdd: "Add details",
    DishesAdd: "Add dishes",
    VisitTime: "Visit time",
    VisitTimeHint: "Enter visit time",
    TicketsBuy: "Where to buy tickets",
    TicketsBuyHint: "Enter where to buy tickets",
    Website: "Website",
    WebsiteHint: "Enter website",
    Place: "Place",
    PlaceHint: "Select place",
    Address: "Address",
    AddressHint: "Enter address",
    MoreInformations: "More informations",
    MoreInformationsHint: "Enter more informations",
    UniqueId: "Unique ID",
    UniqueIdHint: "Enter unique ID (a-z 0-9 _)"
  },

  language: {
    Polish: "Polish",
    English: "English",
    German: "German",
    Spanish: "Spanish",
    AITranslate: "AI translate"
  },

  ai: {
    translationNotAvailable: "AI translation is currently unavailable.",
    serviceNotAvailable: "AI service not available."
  },

  addressPopup: {
    copyAddress: "📋 Copy address",
    copyGPS: "📍 Copy GPS coordinates",
    openMaps: "🗺 Open in maps"
  },

  state: {
    placeNew: "New",
    placeInPreparation: "In preparation",
    placePublished: "Published"
  },

  waitingList: {
    Sign: "Sign up",
    AlreadyExists: "You are already on the waiting list.",
    Added: "You have been added to the waiting list, thank you for your interest in our app!",
    Title: "Sign up for the waiting list",
    Agreement: "By signing up, you agree to receive information about the Flatlinker app at the provided email address. You can unsubscribe from the received information by emailing newsletter@flatlinker.com with the content: Unsubscribe from the list."
  }
};